import React, { useEffect, useState } from 'react';
import { PagingQuery } from 'tea-component';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { useHistory } from 'umi';
import FirstRowEdition from '@/pages/intelligence/components/TableComponents/components/FirstRowEdition';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import { MetricsTableCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/MetricsTableCloums';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
import { getDetailGameOverviewPath } from '@/pages/intelligence/utils/topchartsUtils';

const getMetricValueOfCvm = (cvm: any, metricKey: string) => {
  if (!cvm || !metricKey) {
    return {};
  }
  const metrics = cvm.metric_info || [];
  const metric = metrics.find((item: any) => {
    return item?.metric === metricKey;
  });
  if (metricKey?.indexOf('ofCompany') > -1) {
    return { ...metric, value: metric?.dod_int, growth_ratio: metric?.dod_int };
  }
  return { ...metric, value: metric?.value, growth_ratio: metric?.dod_int };
};

const TrendsCard = (props: any) => {
  const {
    tableData = [],
    pageId,
    dateType,
    tableTotal,
    dataSource = 'appannie',
    columnsList,
    tableLoading,
    onTableSortChage,
    onTablePagingChange,
    entityType,
  } = props;

  const { formatMessage } = useIntlExtend();

  const history = useHistory();
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortAttr, setPageSortAttr] = useState({
    currentSortValue: 'desc',
    currentSortMetric: 'revenue',
    currentRatioType: 0,
  });
  const defaultPageSize = 5;
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const {
    // tablePageIndex,
    // tablePageSize,
    currentSortValue,
    currentSortMetric,
    currentRatioType,
    // currentOrderSource,
  } = pageSortAttr || {};

  useEffect(() => {
    setSortTableData(tableData);
  }, [JSON.stringify(tableData)]);

  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e?.ratioType || 0,
    });
    onTableSortChage(e);
    //将页码重置,与接口一至
    setPageIndex(1);
    setPageSize(defaultPageSize);
  };

  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    columnsList?.forEach((t: any) => {
      metricCloums.push(
        MetricsTableCloums({
          /**MetricsTable页只有降序功能 */
          onlySimpleSort: false,
          renderType: t?.renderType,
          width: t?.width,
          width_cn: t?.width_cn,
          dataSource: t?.dataSource, //source === 'ogdb' ? 'databarin' : source,
          title: t?.text,
          textContent: t?.info,
          tipText: t?.iconInfo,
          key: `${t?.value}`,
          sortMetric: t?.value,
          currentSortValue: currentSortValue,
          currentSortKey: `${currentSortMetric}_${currentRatioType}`,
          onSortChage: onSortChage,
          dateType: dateType,
          pageId: pageId,
          getMetricValueOfCvm: getMetricValueOfCvm,
          growthValueType: 'percentValue',
          formatMessage,
          entityType
        }),
      );
    });
    return metricCloums;
  };

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || defaultPageSize);
    onTablePagingChange(e);
  };

  const onClickGame = (gameId: string) => {
    history.push(getDetailGameOverviewPath(gameId, entityType));
  };

  return (
    <>
      <TopchartTable
        recordKey="app_id"
        loading={tableLoading}
        records={sortTableData}
        tableTotal={tableTotal}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        pageSizeOptions={[5, 10, 15]}
        className="dbi-mobileGames-details-table"
        columns={[
          {
            key: 'game_id',
            header: (
              <div className="stats-table-title">
                <span className="stats-table-title-text">
                  {formatMessage({ id: 'dbi_games' })}
                </span>
                <span className="stats-table-title-subtext">
                  ({tableTotal || 0})
                </span>
              </div>
            ),
            width: 300,
            align: 'left',
            render: (cvm: any) => {
              if (cvm?.id === 'All Games') {
                return <>{formatMessage({ id: 'dbi_detail_table_allgames' })}</>;
              }
              return (
                <ARightClickToJump
                  href={getDetailGameOverviewPath(cvm?.game_id, entityType)}
                  style={{ display: 'inline' }}
                >
                  <FirstRowEdition
                    name={cvm?.game_name === 'Total' ? formatMessage({ id: 'dbi_detail_table_total' }) : cvm?.game_name}
                    isUnPublished={false}
                    platform={cvm?.platform}
                    imgSrc={cvm?.cover}
                    onClick={() => {
                      onClickGame(cvm?.game_id);
                    }}
                  />
                </ARightClickToJump>
              );
            },
          },
          ...getMetricCloums(dataSource),
        ]}
      />
    </>
  );
};

export default TrendsCard;
